import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'
import * as pbi from 'powerbi-client';

declare var jquery: any;
declare var $: any;
@Component({
  templateUrl: './AppViews/powerbi/powerbi.html',

})

export class PowerbiComponent implements OnInit {

  constErrors: any;
  messageType: any;
  spinnerVisible: any = false;
  userDetail: any;
  public BIAccessTokenDetails: any;
  public predefinedFilter1: any;
  constants: Constants;
  public menuAccessList: any = null;
  masterSideMenu: any;
  menuValueId: any;
  menuItems: any[];
  defaultReport:any;

  constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
    this.constants = new Constants();
    if (window.location.href.indexOf('swan') > 0) {
      this.menuValueId = this.constants.PwerBiMenu.Swan;
    }
    else if (window.location.href.indexOf('emqube') > 0) {
     // this.menuValueId = this.constants.PwerBiMenu.Emqube;
     this.menuValueId = 153;
    }
    else
    {
      this.menuValueId = 153;
    }
  }

  ngOnInit() {
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    this.menuItems = JSON.parse(localStorage.getItem("menuItems"));
    this.getSiteUserMenuAccess();

    //this.getAccessToken();
  }


  public getSiteUserMenuAccess() {
    this.menuAccessList =[];
    this.menuAccessList = this.menuItems.filter(x=>x.ParentId==this.menuValueId);
    if (this.menuAccessList.length > 0) {
      setTimeout(() => {
        //$('#tab' + this.menuAccessList[0].MenuId).addClass("active");
        this.sidePanelClick(this.menuAccessList[0]);
      }, 0);
    }
  }


  public sidePanelClick(item) {
    this.defaultReport=item.MenuId;
    this.menuAccessList.forEach(element => {
      $('#' + element.MenuId).removeClass("active");
    });


    //$('#' + item.MenuId).addClass("active");
    //this.loadReport(item.PageUrl,item.MenuValue);
    this.getAccessToken(item.MenuURL, item.MenuId);

    //alert(item.MenuValue);
  }

  public getAccessToken(url, id) {

    //   this.predefinedFilter1 = new pbi.models.AdvancedFilter({
    //     table: "Lead",
    //     column: "ReferalText"
    //     }, 
    //     "Or",
    //     {
    //         operator: "Contains",
    //         value: "Radio Ads"
    //     },
    //     {
    //         operator: "None",
    //         value: "x"
    //     }
    // );


    var date = new Date();
    var seconds = date.getTime() / 1000; //1440516958
    if (localStorage.getItem("BIAccessDetails") == null || localStorage.getItem("BIAccessDetails") == 'undefined')
      this.BIAccessTokenDetails = null;
    else
      this.BIAccessTokenDetails = JSON.parse(localStorage.getItem("BIAccessDetails"));

    if (this.BIAccessTokenDetails != null && this.BIAccessTokenDetails.expires_on > seconds) {
      this.loadReport(url, id);
    }
    else
    //if()
    {
      this.showSpinner();
      this._httpService.ajaxPost('Common/GetAccessToken', null).subscribe(
        data => {

          // if (data["Message"].MessageTypeValue == this.messageType.Success) {
          this.BIAccessTokenDetails = data["AccessToken"];
          localStorage.setItem("BIAccessDetails", JSON.stringify(this.BIAccessTokenDetails));
          this.loadReport(url, id);
          // } else {
          //  this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
          // }
          this.hideSpinner();
        },
        err => {
          console.log("Report Failed");
          this.hideSpinner();
          this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
          this.hideSpinner();
        });
    }

  }


  showSpinner() {
    setTimeout(() => {
      this.spinnerVisible = true
    }, 0);
  }

  hideSpinner() {
    setTimeout(() => { this.spinnerVisible = false }, 0);
  }

  loadReport(url, id) {

    //this.BIAccessTokenDetails.access_token = this.BIAccessTokenDetails.access_token;
    //this.reportUrl = this.reportBaseUrl + url;

    let config = {
      type: 'report',
      accessToken: this.BIAccessTokenDetails.access_token,
      embedUrl: "https://app.powerbi.com/reportEmbed?reportId=" + url,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: true
      }
    };


    // Grab the reference to the div HTML element that will host the report.
    let reportContainer = <HTMLElement>document.getElementById('biReportTabContent');

    // Embed the report and display it within the div container.
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    powerbi.reset(reportContainer);
    let report = powerbi.embed(reportContainer, config);

    // Report.off removes a given event handler if it exists.
    report.off("loaded");

    // Report.on will add an event handler which prints to Log window.
    report.on("loaded", function () {
      console.log("Loaded");
    });


  }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/powerbi/Powerbi.component.ts
 **/